<!-- Message Content -->
<p-message styleClass="w-full"
           [severity]="severity"
           [text]="text | translate">
</p-message>